import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';
import { MatchAnalysis, pct } from '../../utils/matchAnalysis';
import { teamAbbr } from './TeamLogo';

interface MarketTilesProps {
  match: MatchAnalysis;
  league: string;
}

const MarketTiles: React.FC<MarketTilesProps> = ({ match, league }) => {
  const { t } = useTranslation();
  const d = t.matchDashboard;
  const abbr = { home: teamAbbr(match.home, league), away: teamAbbr(match.away, league) };

  const footballTiles = match.threeWay
    ? [
        { label: `12 · ${d.noDraw}`, value: match.doubleChance.either },
        { label: d.btts, value: match.btts.yes },
        { label: `${d.btts} & ${d.over} 2.5`, value: match.btts.over25 },
        { label: `${abbr.home} ${d.winToNil}`, value: match.winToNil.home },
        { label: `${abbr.away} ${d.winToNil}`, value: match.winToNil.away },
        ...match.correctScores.map((s) => ({ label: `${d.correctScore} ${s.label}`, value: s.value })),
      ]
    : [];

  const tiles = [
    { label: `${abbr.home} · 1X`, value: match.doubleChance.home },
    { label: `${abbr.away} · X2`, value: match.doubleChance.away },
    ...footballTiles,
    { label: `${abbr.home} −1.5`, value: match.handicap.home },
    { label: `${abbr.away} −1.5`, value: match.handicap.away },
    ...match.combos.map((c) => ({
      label: `${abbr[c.side]} ${d.win} & ${c.kind === 'o' ? d.over : d.under} ${c.line}`,
      value: c.value,
    })),
  ];

  return (
    <div className="dash-card dash-card--wide">
      <div className="dash-card__head">
        <h3 className="dash-card__title">{d.markets}</h3>
      </div>
      <div className="market-tiles">
        {tiles.map((tile) => (
          <div key={tile.label} className="market-tiles__tile">
            <span className="market-tiles__label">{tile.label}</span>
            <span className="market-tiles__value">{pct(tile.value, 1)}</span>
            <span className="market-tiles__meter">
              <span style={{ width: pct(tile.value, 2) }} />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketTiles;
